import { format, isValid } from 'date-fns';
import { ptBR } from 'date-fns/locale';
import { ModeBarDefaultButtons } from 'plotly.js';
import { DayConfig } from '../../../models/DayConfig';
import { DayDelete } from '../../../models/DayDelete';
import { WeekConfig } from '../../../models/WeekConfig';
import { Theme } from '../../theme/theme';
import { GeneratedChart, Schedule } from '../api/types';
import { getDefaultXTimestamps } from './timeInput';

export type MenuIcons = keyof typeof menuIcons;
export const menuIcons = {
  csvFile: {
    width: 548.29,
    height: 548.291,
    path:
      'M486.2,196.121h-13.164V132.59c0-0.399-0.064-0.795-0.116-1.2c-0.021-2.52-0.824-5-2.551-6.96L364.656,3.677 c-0.031-0.034-0.064-0.044-0.085-0.075c-0.629-0.707-1.364-1.292-2.141-1.796c-0.231-0.157-0.462-0.286-0.704-0.419 c-0.672-0.365-1.386-0.672-2.121-0.893c-0.199-0.052-0.377-0.134-0.576-0.188C358.229,0.118,357.4,0,356.562,0H96.757 C84.893,0,75.256,9.649,75.256,21.502v174.613H62.093c-16.972,0-30.733,13.756-30.733,30.73v159.81 c0,16.966,13.761,30.736,30.733,30.736h13.163V526.79c0,11.854,9.637,21.501,21.501,21.501h354.777 c11.853,0,21.502-9.647,21.502-21.501V417.392H486.2c16.966,0,30.729-13.764,30.729-30.731v-159.81 C516.93,209.872,503.166,196.121,486.2,196.121z M96.757,21.502h249.053v110.006c0,5.94,4.818,10.751,10.751,10.751h94.973v53.861 H96.757V21.502z M258.618,313.18c-26.68-9.291-44.063-24.053-44.063-47.389c0-27.404,22.861-48.368,60.733-48.368 c18.107,0,31.447,3.811,40.968,8.107l-8.09,29.3c-6.43-3.107-17.862-7.632-33.59-7.632c-15.717,0-23.339,7.149-23.339,15.485 c0,10.247,9.047,14.769,29.78,22.632c28.341,10.479,41.681,25.239,41.681,47.874c0,26.909-20.721,49.786-64.792,49.786 c-18.338,0-36.449-4.776-45.497-9.77l7.38-30.016c9.772,5.014,24.775,10.006,40.264,10.006c16.671,0,25.488-6.908,25.488-17.396 C285.536,325.789,277.909,320.078,258.618,313.18z M69.474,302.692c0-54.781,39.074-85.269,87.654-85.269 c18.822,0,33.113,3.811,39.549,7.149l-7.392,28.816c-7.38-3.084-17.632-5.939-30.491-5.939c-28.822,0-51.206,17.375-51.206,53.099 c0,32.158,19.051,52.4,51.456,52.4c10.947,0,23.097-2.378,30.241-5.238l5.483,28.346c-6.672,3.34-21.674,6.919-41.208,6.919 C98.06,382.976,69.474,348.424,69.474,302.692z M451.534,520.962H96.757v-103.57h354.777V520.962z M427.518,380.583h-42.399 l-51.45-160.536h39.787l19.526,67.894c5.479,19.046,10.479,37.386,14.299,57.397h0.709c4.048-19.298,9.045-38.352,14.526-56.693 l20.487-68.598h38.599L427.518,380.583z',
  },
  gear: {
    width: 21,
    height: 21,
    path:
      'M11.8556 2.73159C11.5436 1.13213 9.25522 1.13213 8.94318 2.73159C8.60844 4.44745 6.71706 5.35829 5.16684 4.55018C3.72178 3.7969 2.29499 5.58603 3.35095 6.82724C4.48375 8.15877 4.01662 10.2054 2.41827 10.9136L2.18899 10.3961L2.41827 10.9136C0.928347 11.5737 1.43756 13.8047 3.06635 13.753C4.81368 13.6976 6.12255 15.3388 5.67966 17.03C5.26682 18.6065 7.32859 19.5994 8.3037 18.2937C9.34978 16.893 11.449 16.893 12.4951 18.2937C13.4702 19.5993 15.532 18.6065 15.1192 17.03C14.6763 15.3388 15.9852 13.6976 17.7325 13.753C19.3613 13.8047 19.8705 11.5737 18.3806 10.9136C16.7822 10.2054 16.3151 8.15877 17.4479 6.82724C18.5038 5.58603 17.077 3.7969 15.632 4.55018C14.0818 5.35829 12.1904 4.44745 11.8556 2.73159ZM7.83215 2.51484C8.38226 -0.304914 12.4166 -0.304914 12.9667 2.51484C13.1566 3.48813 14.2294 4.00479 15.1087 3.5464C17.6563 2.2184 20.1716 5.37256 18.3101 7.56073C17.6675 8.31602 17.9325 9.47694 18.8391 9.87863C21.4658 11.0424 20.568 14.9756 17.6966 14.8844C16.7054 14.853 15.963 15.7839 16.2142 16.7432C16.942 19.5224 13.3072 21.2729 11.5882 18.971C10.9948 18.1765 9.80403 18.1765 9.21066 18.971C7.49159 21.2729 3.8568 19.5224 4.58462 16.7432C4.83584 15.7839 4.0934 14.853 3.10226 14.8844C0.230798 14.9756 -0.666923 11.0424 1.95972 9.87863C2.86636 9.47694 3.13133 8.31602 2.48877 7.56073C0.627181 5.37256 3.14254 2.2184 5.69009 3.5464C6.56943 4.00479 7.64228 3.48813 7.83215 2.51484ZM10.3994 8.26617C9.11843 8.26617 8.07998 9.30462 8.07998 10.5856C8.07998 11.8666 9.11843 12.905 10.3994 12.905C11.6804 12.905 12.7189 11.8666 12.7189 10.5856C12.7189 9.30462 11.6804 8.26617 10.3994 8.26617ZM6.94801 10.5856C6.94801 8.67945 8.49325 7.1342 10.3994 7.1342C12.3056 7.1342 13.8508 8.67945 13.8508 10.5856C13.8508 12.4918 12.3056 14.037 10.3994 14.037C8.49325 14.037 6.94801 12.4918 6.94801 10.5856Z',
  },
  trashCan: {
    width: 14,
    height: 14,
    path:
      'M1.75 4.66667H12.25V12.25C12.25 13.2165 11.4665 14 10.5 14H3.5C2.5335 14 1.75 13.2165 1.75 12.25V4.66667ZM5.25 11.0833V7H4.08333V11.0833H5.25ZM7.58333 11.0833V7H6.41667V11.0833H7.58333ZM9.91667 11.0833V7H8.75V11.0833H9.91667ZM13.4167 2.33333C13.7388 2.33333 14 2.5945 14 2.91667C14 3.23883 13.7388 3.5 13.4167 3.5H0.583333C0.261167 3.5 0 3.23883 0 2.91667C0 2.5945 0.261167 2.33333 0.583333 2.33333H4.08333V0.583333C4.08333 0.261167 4.3445 0 4.66667 0H9.33333C9.6555 0 9.91667 0.261167 9.91667 0.583333V2.33333H13.4167ZM5.25 1.16667V2.33333H8.75V1.16667H5.25Z',
  },
  check: {
    width: 512,
    height: 382,
    path:
      'M173.898 374.404L7.49799 208.004C-2.49901 198.007 -2.49901 181.798 7.49799 171.8L43.701 135.596C53.698 125.598 69.908 125.598 79.905 135.596L192 247.69L432.095 7.59602C442.092 -2.40098 458.302 -2.40098 468.299 7.59602L504.502 43.8C514.499 53.797 514.499 70.006 504.502 80.004L210.102 374.405C200.104 384.402 183.895 384.402 173.898 374.404V374.404Z',
  },
  cross: {
    width: 15,
    height: 15,
    path:
      'M14.285 2.00116C14.4084 1.87818 14.5064 1.73205 14.5732 1.57116C14.64 1.41026 14.6744 1.23776 14.6744 1.06354C14.6744 0.889322 14.64 0.716819 14.5732 0.555922C14.5064 0.395024 14.4084 0.248898 14.285 0.125922C14.1863 0.0445173 14.0623 0 13.9343 0C13.8063 0 13.6823 0.0445173 13.5835 0.125922L7.5 6.21271L2.00116 0.714966C1.87818 0.591563 1.73205 0.493649 1.57116 0.426839C1.41026 0.36003 1.23776 0.325639 1.06354 0.325639C0.889322 0.325639 0.716819 0.36003 0.555922 0.426839C0.395024 0.493649 0.248898 0.591563 0.125922 0.714966C0.0445173 0.813739 0 0.93775 0 1.06575C0 1.19374 0.0445173 1.31775 0.125922 1.41652L6.21271 7.5L0.714966 12.9988C0.591563 13.1218 0.493649 13.2679 0.426839 13.4288C0.36003 13.5897 0.325639 13.7622 0.325639 13.9365C0.325639 14.1107 0.36003 14.2832 0.426839 14.4441C0.493649 14.605 0.591563 14.7511 0.714966 14.8741C0.813739 14.9555 0.93775 15 1.06575 15C1.19374 15 1.31775 14.9555 1.41652 14.8741L7.5 8.78729L12.9988 14.2861C13.1218 14.4095 13.2679 14.5075 13.4288 14.5743C13.5897 14.6411 13.7622 14.6755 13.9365 14.6755C14.1107 14.6755 14.2832 14.6411 14.4441 14.5743C14.605 14.5075 14.7511 14.4095 14.8741 14.2861C14.9555 14.1874 15 14.0634 15 13.9354C15 13.8074 14.9555 13.6834 14.8741 13.5846L8.78729 7.5L14.285 2.00116Z',
  },
  pencil: {
    width: 469.336,
    height: 469.336,
    path:
      'M347.878 151.357c-4-4.003-11.083-4.003-15.083 0L129.909 354.414a10.7 10.7 0 0 0-2.99 9.258 10.693 10.693 0 0 0 5.76 7.84l16.656 8.34v28.049l-51.031 14.602-51.51-51.554 14.59-51.075h28.025l8.333 16.67a10.682 10.682 0 0 0 7.833 5.765c.573.094 1.146.135 1.708.135a10.64 10.64 0 0 0 7.542-3.128L317.711 136.26c2-2.002 3.125-4.712 3.125-7.548 0-2.836-1.125-5.546-3.125-7.548l-39.229-39.263a10.653 10.653 0 0 0-7.542-3.128h-.021a10.67 10.67 0 0 0-7.552 3.159L45.763 301.682c-.105.107-.1.27-.201.379-1.095 1.183-2.009 2.549-2.487 4.208l-18.521 64.857L.409 455.73a10.682 10.682 0 0 0 10.261 13.606c.979 0 1.958-.136 2.927-.407l84.531-24.166 64.802-18.537c.195-.056.329-.203.52-.27.673-.232 1.262-.61 1.881-.976.608-.361 1.216-.682 1.73-1.146.138-.122.319-.167.452-.298l219.563-217.789a10.689 10.689 0 0 0 3.156-7.558 10.655 10.655 0 0 0-3.125-7.569l-39.229-39.263zM456.836 76.168l-64-64.054c-16.125-16.139-44.177-16.17-60.365.031l-39.073 39.461c-4.135 4.181-4.125 10.905.031 15.065l108.896 108.988a10.629 10.629 0 0 0 7.542 3.128c2.719 0 5.427-1.032 7.51-3.096l39.458-39.137c8.063-8.069 12.5-18.787 12.5-30.192s-4.436-22.125-12.499-30.194z',
  },
  comparison: {
    width: 512,
    height: 512,
    path:
      'M271 446.125h192.083a7.5 7.5 0 0 0 7.5-7.5V402.75a7.5 7.5 0 0 0-7.5-7.5H271a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5zm7.5-35.875h177.083v20.875H278.5zm226-146.75H271a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5h233.5a7.5 7.5 0 0 0 7.5-7.5V271a7.5 7.5 0 0 0-7.5-7.5zm-7.5 35.875H278.5V278.5H497zm-226-248.5h192.083a7.5 7.5 0 0 0 7.5-7.5V7.5a7.5 7.5 0 0 0-7.5-7.5H271a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5zM278.5 15h177.083v20.875H278.5zM271 380.25h150.667a7.5 7.5 0 0 0 7.5-7.5v-35.875a7.5 7.5 0 0 0-7.5-7.5H271a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5zm7.5-35.875h135.667v20.875H278.5zm226 116.75H271a7.5 7.5 0 0 0-7.5 7.5V504.5a7.5 7.5 0 0 0 7.5 7.5h233.5a7.5 7.5 0 0 0 7.5-7.5v-35.875a7.5 7.5 0 0 0-7.5-7.5zM497 497H278.5v-20.875H497zm7.5-431.125H271a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5h233.5a7.5 7.5 0 0 0 7.5-7.5V73.375a7.5 7.5 0 0 0-7.5-7.5zM497 101.75H278.5V80.875H497zM271 248.5h67.833a7.5 7.5 0 0 0 7.5-7.5v-35.875a7.5 7.5 0 0 0-7.5-7.5H271a7.5 7.5 0 0 0-7.5 7.5V241a7.5 7.5 0 0 0 7.5 7.5zm7.5-35.875h52.833V233.5H278.5zm-7.5-30h150.667a7.5 7.5 0 0 0 7.5-7.5V139.25a7.5 7.5 0 0 0-7.5-7.5H271a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5zm7.5-35.875h135.667v20.875H278.5zM241 395.25H48.917a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5H241a7.5 7.5 0 0 0 7.5-7.5V402.75a7.5 7.5 0 0 0-7.5-7.5zm-7.5 35.875H56.417V410.25H233.5zM241 263.5H7.5A7.5 7.5 0 0 0 0 271v35.875a7.5 7.5 0 0 0 7.5 7.5H241a7.5 7.5 0 0 0 7.5-7.5V271a7.5 7.5 0 0 0-7.5-7.5zm-7.5 35.875H15V278.5h218.5zM241 0H48.917a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5H241a7.5 7.5 0 0 0 7.5-7.5V7.5A7.5 7.5 0 0 0 241 0zm-7.5 35.875H56.417V15H233.5zm7.5 293.5h-67.833a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5H241a7.5 7.5 0 0 0 7.5-7.5v-35.875a7.5 7.5 0 0 0-7.5-7.5zm-7.5 35.875h-52.833v-20.875H233.5zM241 461.125H7.5a7.5 7.5 0 0 0-7.5 7.5V504.5a7.5 7.5 0 0 0 7.5 7.5H241a7.5 7.5 0 0 0 7.5-7.5v-35.875a7.5 7.5 0 0 0-7.5-7.5zM233.5 497H15v-20.875h218.5zM241 65.875H7.5a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5h41.417a7.5 7.5 0 1 0 0-15H15V80.875h218.5v20.875H78.917a7.5 7.5 0 1 0 0 15H241a7.5 7.5 0 0 0 7.5-7.5V73.375a7.5 7.5 0 0 0-7.5-7.5zm0 131.75H131.75a7.5 7.5 0 0 0-7.5 7.5V241a7.5 7.5 0 0 0 7.5 7.5H241a7.5 7.5 0 0 0 7.5-7.5v-35.875a7.5 7.5 0 0 0-7.5-7.5zm-7.5 35.875h-94.25v-20.875h94.25zm7.5-101.75H48.917a7.5 7.5 0 0 0-7.5 7.5v35.875a7.5 7.5 0 0 0 7.5 7.5H241a7.5 7.5 0 0 0 7.5-7.5V139.25a7.5 7.5 0 0 0-7.5-7.5zm-7.5 35.875H56.417V146.75H233.5z',
  },
  graph: {
    width: 18.777,
    height: 18.777,
    path:
      'M2.245 10.496H.272A.274.274 0 0 0 0 10.77v5.717c0 .15.122.272.272.272h1.973c.15 0 .272-.122.272-.272V10.77a.273.273 0 0 0-.272-.274zM18.504 10.496h-1.973a.273.273 0 0 0-.271.274v5.717c0 .15.121.272.271.272h1.973a.272.272 0 0 0 .273-.272V10.77a.274.274 0 0 0-.273-.274zM5.907 7.228H3.934a.273.273 0 0 0-.273.273v8.984c0 .15.123.272.273.272h1.973a.272.272 0 0 0 .273-.272V7.501a.272.272 0 0 0-.273-.273zM14.271 7.228h-1.973a.272.272 0 0 0-.271.273v8.984c0 .15.121.272.271.272h1.973a.272.272 0 0 0 .273-.272V7.501a.27.27 0 0 0-.273-.273zM10.01 9.218H8.036a.273.273 0 0 0-.272.272v6.994c0 .15.122.272.272.272h1.974a.272.272 0 0 0 .273-.272V9.49a.272.272 0 0 0-.273-.272z M1.259 6.947A1.05 1.05 0 0 0 2.31 5.896c0-.101-.019-.196-.046-.288l2.211-1.591c.136.064.286.102.446.102.309 0 .583-.135.776-.347L7.784 4.98c-.012.062-.02.126-.02.19a1.047 1.047 0 1 0 2.095.062l2.814-.823c.191.262.498.435.848.435.232 0 .443-.077.617-.205l2.365 1.604a1.11 1.11 0 0 0-.037.26 1.052 1.052 0 1 0 1.051-1.051 1.04 1.04 0 0 0-.617.204l-2.363-1.601a1.05 1.05 0 0 0-2.061-.322l-2.813.822a1.038 1.038 0 0 0-1.523-.184L5.968 3.112c0-.015.004-.028.004-.042a1.051 1.051 0 1 0-2.102-.001c0 .158.038.306.1.441L1.855 5.032a1.05 1.05 0 1 0-.596 1.915z',
  },
};

export const DEFAULT_CHART = {
  axis: [],
  title: 'Gráfico Vazio',
  type: 'line',
} as GeneratedChart;

export type MenuItem =
  | {
      icon: MenuIcons;
      visible: boolean;
      hint: string;
      click: () => void;
    }
  | ModeBarDefaultButtons;

export type TabItem = {
  label: string;
  formatting?: {
    title: string;
    toggleAxis: (0 | 1)[];
  };
  click: () => void;
};

/**
 * This function asserts that the provided item has a property named active
 *
 * @param item Item to be tested
 */
export function assertHasActive(
  item: unknown
): asserts item is { active: unknown } {
  if (!Object.prototype.hasOwnProperty.call(item, 'active'))
    throw new Error('No active item on tabs on charts');
}

/**
 * @param chart Any chart that is accepted by the SChart component
 * @returns The equivalent CSV
 */
export function chartToCSV(chart: GeneratedChart): string {
  const header: string[] = [];
  const lines: Record<string, Record<string, unknown>> = {};

  chart.axis.forEach((axis) => {
    header.push(axis.label);
    axis.X.forEach((x, i) => {
      if (lines[x]) lines[x][axis.label] = axis.Y[i];
      else lines[x] = { [axis.label]: axis.Y[i] };
    });
  });
  const csv = Object.keys(lines)
    .sort()
    .map((index) => {
      if (!isValid(new Date(index)))
        return `${index};${header.map((head) => lines[index][head]).join(';')}`;

      const dateFormat = 'dd/MM/yyyy HH:mm:ss';
      const date = format(new Date(index), dateFormat, { locale: ptBR });
      return `${date};${header.map((head) => lines[index][head]).join(';')}`;
    })
    .join('\n');
  return `data:text/csv;charset=utf-8,data;${header.join(';')}\n${csv}`;
}

/**
 * Downloads a single file.
 *
 * @param content Content of the file to download
 * @param sugestedName Sugested name of the downloaded file
 */
export function downloadFile(content: string, sugestedName: string): void {
  const link = document.createElement('a');
  const encodedUri = encodeURI(
    content
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .toLowerCase()
  );

  link.setAttribute('href', encodedUri);
  link.setAttribute('download', sugestedName);

  document.body.appendChild(link);

  link.click();

  document.body.removeChild(link);
}

type HistoricSchedule =
  | WeekConfig['Data']
  | DayConfig['Data']
  | DayDelete['Data'];

/**
 * Transforms a historic schedule into a chart.
 *
 * @param schedule A schedule to convert to chart
 * @returns A valid chart
 */
export function historicScheduleToChart(
  schedule: HistoricSchedule
): GeneratedChart {
  return {
    title: schedule.Id as string,
    type: 'line',
    axis: [
      {
        label: 'Potência da Rede Máxima',
        X: getDefaultXTimestamps(),
        Y: schedule.PgridMax as number[],
      },
      {
        label: 'Potência de Carga PCS',
        X: getDefaultXTimestamps(),
        Y: schedule.PpcsChgMax as number[],
      },
      {
        label: 'Potência de Descarga PCS',
        X: getDefaultXTimestamps(),
        Y: schedule.PpcsDsgMax as number[],
      },
      {
        label: 'Fator de Potência',
        X: getDefaultXTimestamps(),
        Y: schedule.Fp as number[],
      },
    ],
  };
}

/**
 * Transforms a template schedule into a chart.
 *
 * @param schedule A schedule to convert to chart
 * @returns A valid chart
 */
export function scheduleToChart(schedule: Schedule): GeneratedChart {
  return {
    title: schedule.name,
    type: 'line',
    axis: [
      {
        label: 'Potência da Rede Máxima',
        X: getDefaultXTimestamps(),
        Y: schedule.pgridMax,
      },
      {
        label: 'Potência de Carga PCS',
        X: getDefaultXTimestamps(),
        Y: schedule.ppcsChgMax,
      },
      {
        label: 'Potência de Descarga PCS',
        X: getDefaultXTimestamps(),
        Y: schedule.ppcsDsgMax,
      },
      {
        label: 'Fator de Potência',
        X: getDefaultXTimestamps(),
        Y: schedule.fp,
      },
    ],
  };
}

/**
 * Returns the x component of a chart ready to plot.
 *
 * @param x The x component of a chart, it can be either a string array of
 * iso8601 dates, a string array of any regular dates, a Date object, or a
 * string array unrelated to dates (monday, tuesday, etc)
 * @returns
 */
export function parseX(x: (Date | string)[]): (Date | string)[] {
  return x.map((value) => {
    const asDate = new Date(value);
    if (isValid(asDate)) return asDate;
    else if (typeof value === 'string') return value;
    throw new Error('Invalid Date format');
  });
}

/**
 * Returns the color of one of the axis
 *
 * @param type Type of the graph, can be for now line and bar
 * @param position Position of the axis, a 0-based index from the first curve
 * to the last.
 * @param theme The current theme of the application
 */
export function colorOfCurve(
  type: 'line' | 'bar',
  position: number,
  theme: Theme
): string {
  const lineColors = [
    theme.pallete.secondary.main,
    theme.pallete.primary.main,
    theme.pallete.primary.light,
    theme.pallete.success.main,
    theme.pallete.success.dark,
    theme.pallete.accent.light,
    theme.pallete.secondary.dark
  ] as string[];

  const barColors = [
    theme.pallete.primary.light,
    theme.pallete.primary.main,
  ] as string[];

  if (type === 'line') return lineColors[position % lineColors.length];
  else if (type === 'bar') return barColors[position % barColors.length];
  throw new Error('Invalid chart type');
}

/**
 * @param mode Current schedule's page mode
 * @param options Options to decide on the correct naming of the current
 * displayed chart
 * @returns The correct naming of the current Chart to be displayed
 */
export function scheduleChartNaming(
  mode: 'VIEW' | 'SCHEDULE',
  options: {
    selectedDay?: Date;
    schedules?: Schedule[];
    selectedSchedule?: number;
    isWeekDaySelected?: boolean;
  }
): string {
  const {
    selectedSchedule,
    selectedDay,
    isWeekDaySelected,
    schedules,
  } = options;

  if (mode === 'VIEW' && selectedDay && isWeekDaySelected) {
    const formattedTime = format(selectedDay, 'cccc', { locale: ptBR });
    return `Programação Recorrente (${formattedTime})`;
  } else if (mode === 'VIEW' && selectedDay && !isWeekDaySelected) {
    const formattedTime = format(selectedDay, 'PPPP', { locale: ptBR });
    return `Programação de ${formattedTime}`;
  } else if (
    mode === 'SCHEDULE' &&
    selectedSchedule !== undefined &&
    schedules
  ) {
    return `Template de Programação (${schedules[selectedSchedule].name})`;
  } else if (mode === 'VIEW') {
    return 'Selecione um Dia';
  } else if (mode === 'SCHEDULE') {
    return 'Selecione uma Programação';
  }
  throw new Error(`Modo desconhecido ${mode}`);
}
